import React from 'react'
import { Button, Input, Loading, PageTitle, Popup } from 'src/components'
import { useStyles } from './styles'
import ImageUpload from './components/ImageUpload'
import ChangePassword from './components/ChangePassword'
import { useProfile } from './hooks/useProfile'
import { cpfMask, phoneMask } from 'src/utils'
import { useGetUserList } from 'src/hooks/api/user'
import { useAuth } from 'src/contexts/auth'
import { useForm } from 'react-hook-form'
import { UserParams } from 'src/domain/User/UserDomain'
import { yupResolver } from '@hookform/resolvers/yup'
import { VALIDATIONS } from 'src/@types/validations'

export const Perfil: React.FC = () => {
  const style = useStyles()
  const { username: userId } = useAuth()
  const { data: userList, isLoading } = useGetUserList()

  const {
    watch,
    setValue,
    clearErrors,
    handleSubmit,
    reset,
    formState: { errors, isDirty }
  } = useForm<UserParams>({
    resolver: yupResolver(VALIDATIONS.User.userProfileSchema),
    defaultValues: {
      nome: '',
      sobrenome: '',
      documento: '',
      telefone: ''
    }
  })

  const { handleOpenPopup, handleClosePopup, isOpenChangePasswordModal, onSubmit, isSaving } = useProfile({
    userId: userId!,
    userList: userList || [],
    reset
  })

  const userInitial = watch('nome')?.charAt(0).toUpperCase() || ''

  return (
    <>
      <PageTitle title='Perfil' />
      {isLoading ? (
        <Loading />
      ) : (
        <div className={style.perfilContainer}>
          <div className={style.perfilContainerContent}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <fieldset className={style.perfilFieldset}>
                {/* Avatar */}
                <div className={`${style.perfilFormItem} ${style.perfiLFormItemCenter}`}>
                  <div className={style.userInicial}>{userInitial}</div>
                  <ImageUpload />
                </div>

                {/* Campos */}
                <div className={style.perfilFormItem}>
                  <Input
                    type='text'
                    label='Nome'
                    value={watch('nome')}
                    error={errors?.nome?.message}
                    onChange={(value: string) => {
                      const sanitized = value.replace(/\s/g, '')
                      setValue('nome', sanitized, { shouldDirty: true })
                      clearErrors('nome')
                    }}
                  />

                  <Input
                    type='text'
                    label='Sobrenome'
                    value={watch('sobrenome')}
                    error={errors?.sobrenome?.message}
                    onChange={(item: string) => {
                      setValue('sobrenome', item, { shouldDirty: true })
                      clearErrors('sobrenome')
                    }}
                  />

                  <Input
                    type='text'
                    label='CPF'
                    value={cpfMask(watch('documento') || '')}
                    error={errors?.documento?.message}
                    onChange={(item: string) => {
                      setValue('documento', item, { shouldDirty: true })
                      clearErrors('documento')
                    }}
                  />

                  <Input
                    type='text'
                    label='Telefone'
                    value={phoneMask(watch('telefone') || '')}
                    disabled
                    error={errors?.telefone?.message}
                    onChange={(item: string) => {
                      setValue('telefone', item, { shouldDirty: true })
                      clearErrors('telefone')
                    }}
                  />
                </div>

                {/* Ações */}
                <div className={style.perfilButtonsContainer}>
                  <Button
                    type='button'
                    onClick={handleOpenPopup}
                    outlined
                    className={style.perfilButton}
                    disabled={isSaving}
                  >
                    Alterar senha
                  </Button>

                  {isDirty && (
                    <Button className={style.perfilButton} type='submit' isLoading={isSaving} disabled={isSaving}>
                      Atualizar
                    </Button>
                  )}
                </div>
              </fieldset>
            </form>
          </div>

          {isOpenChangePasswordModal && (
            <Popup title='Alterar Senha' className={style.popupChangePassword} onClose={handleClosePopup}>
              <ChangePassword onClose={handleClosePopup} />
            </Popup>
          )}
        </div>
      )}
    </>
  )
}
